import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { PaymentV2Service } from '../../shared/services';

@Component({
  selector: 'app-sip-info',
  templateUrl: './sip-info.component.html',
  styleUrls: ['./sip-info.component.scss']
})
export class SipInfoComponent implements OnInit, OnChanges {

  @Input() config;

  infoText = [
    { text: '' },
    { text: 'Receive <strong>monthly updates</strong> on your funds' },
    { text: '<strong>Choose</strong> causes, amount and beneficiery' },
    { text: 'Unlock special <strong>rewards</strong>' }
  ];

  constructor(
    private paymentV2: PaymentV2Service
  ) { }

  ngOnInit(): void {
    this.setdata(this.config?.currency);
  }

  ngOnChanges(): void {
    this.paymentV2.paymentConfig.subscribe((res) => {
      if (res?.currency) {
        this.setdata(res?.currency);
      }
    })
  }

  setdata(item) {
    if (item && item?.toUpperCase() !== 'INR') {
      this.infoText[0].text = '<strong>Pause or cancel</strong> subscription anytime';
    } else {
      this.infoText[0].text = 'Receive <strong>Tax benefits</strong>';
    }
  }

}
